
const state = {
  list: []
}

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
